/* eslint-disable */
/**
 * Export default locale
 */
export var defaultLocale = {
    'alignments': 'Alignments',
    'justifyLeft': 'Align Left',
    'justifyCenter': 'Align Center',
    'justifyRight': 'Align Right',
    'justifyFull': 'Align Justify',
    'fontName': 'Font Name',
    'fontSize': 'Font Size',
    'fontColor': 'Font Color',
    'backgroundColor': 'Background Color',
    'bold': 'Bold',
    'italic': 'Italic',
    'underline': 'Underline',
    'strikethrough': 'Strikethrough',
    'clearFormat': 'Clear Format',
    'clearAll': 'Clear All',
    'cut': 'Cut',
    'copy': 'Copy',
    'paste': 'Paste',
    'unorderedList': 'Bulleted List',
    'orderedList': 'Numbered List',
    'indent': 'Increase Indent',
    'outdent': 'Decrease Indent',
    'undo': 'Undo',
    'redo': 'Redo',
    'superscript': 'Superscript',
    'subscript': 'Subscript',
    'createLink': 'Insert Link',
    'openLink': 'Open Link',
    'editLink': 'Edit Link',
    'removeLink': 'Remove Link',
    'image': 'Insert Image',
    'audio': 'Insert Audio',
    'video': 'Insert Video',
    'replace': 'Replace',
    'numberFormatList': 'Number Format List',
    'bulletFormatList': 'Bullet Format List',
    'audioReplace': 'Replace',
    'videoReplace': 'Replace',
    'videoAlign': 'Align',
    'videoDimension': 'Dimension',
    'audioRemove': 'Remove',
    'videoRemove': 'Remove',
    'audioLayoutOption': 'Layout option',
    'videoLayoutOption': 'Layout option',
    'align': 'Align',
    'caption': 'Caption',
    'remove': 'Remove',
    'insertLink': 'Insert Link',
    'display': 'Display',
    'altText': 'Alternative text',
    'dimension': 'Change Size',
    'fullscreen': 'Maximize',
    'maximize': 'Maximize',
    'minimize': 'Minimize',
    'lowerCase': 'Lower Case',
    'upperCase': 'Upper Case',
    'print': 'Print',
    'formats': 'Formats',
    'sourcecode': 'Code View',
    'preview': 'Preview',
    'viewside': 'ViewSide',
    'insertCode': 'Insert Code',
    'blockquote': 'Blockquote',
    'linkText': 'Display text',
    'linkTooltipLabel': 'Title',
    'linkWebUrl': 'Web address',
    'linkTitle': 'Enter a title',
    'linkurl': 'https://example.com',
    'linkOpenInNewWindow': 'Open link in new window',
    'linkHeader': 'Insert Link',
    'dialogInsert': 'Insert',
    'dialogCancel': 'Cancel',
    'dialogUpdate': 'Update',
    'imageHeader': 'Insert Image',
    'audioHeader': 'Insert Audio',
    'videoHeader': 'Insert Video',
    'imageLinkHeader': 'You can also provide a link from the web',
    'audioLinkHeader': 'You can also provide a link from the web',
    'videoLinkHeader': 'Web URL',
    'embedVideoLinkHeader': 'Media Embed URL',
    'mdimageLink': 'Please provide a URL for your image',
    'imageUploadMessage': 'Drop image here or browse to upload',
    'audioUploadMessage': 'Drop an audio file or browse to upload',
    'videoUploadMessage': 'Drop a video file or browse to upload',
    'imageDeviceUploadMessage': 'Click here to upload',
    'audioDeviceUploadMessage': 'Click here to upload',
    'videoDeviceUploadMessage': 'Click here to upload',
    'imageAlternateText': 'Alternate Text',
    'alternateHeader': 'Alternative Text',
    'browse': 'Browse',
    'imageUrl': 'https://example.com/image.png',
    'audioUrl': 'https://example.com/audio.mp3',
    'videoUrl': 'https://example.com/video.mp4',
    'webUrl': 'Web URL',
    'embedUrl': 'Embed Code',
    'imageCaption': 'Caption',
    'imageSizeHeader': 'Image Size',
    'videoSizeHeader': 'Video Size',
    'imageHeight': 'Height',
    'imageWidth': 'Width',
    'videoHeight': 'Height',
    'videoWidth': 'Width',
    'textPlaceholder': 'Enter text',
    'inserttablebtn': 'Insert Table',
    'tabledialogHeader': 'Insert Table',
    'tableWidth': 'Width',
    'cellpadding': 'Cell Padding',
    'cellspacing': 'Cell Spacing',
    'columns': 'Number of columns',
    'rows': 'Number of rows',
    'tableRows': 'Row',
    'tableColumns': 'Column',
    'tableCellHorizontalAlign': 'Table Cell Horizontal Align',
    'tableCellVerticalAlign': 'Vertical Align',
    'createTable': 'Create Table',
    'removeTable': 'Remove Table',
    'tableHeader': 'Header Row',
    'tableRemove': 'Delete Table',
    'tableCellBackground': 'Table Cell Background',
    'tableEditProperties': 'Table Edit Properties',
    'styles': 'Styles',
    'insertColumnLeft': 'Insert Column Left',
    'insertColumnRight': 'Insert Column Right',
    'deleteColumn': 'Delete Column',
    'insertRowBefore': 'Insert Row Before',
    'insertRowAfter': 'Insert Row After',
    'deleteRow': 'Delete Row',
    'tableEditHeader': 'Edit Table',
    'TableHeadingText': 'Heading',
    'TableColText': 'Col',
    'imageInsertLinkHeader': 'Insert Link',
    'editImageHeader': 'Edit Image',
    'editAudioHeader': 'Edit Audio',
    'editVideoHeader': 'Edit Video',
    "alignmentsDropDownLeft": 'Align Left',
    "alignmentsDropDownCenter": 'Align Center',
    "alignmentsDropDownRight": 'Align Right',
    "alignmentsDropDownJustify": 'Align Justify',
    "imageDisplayDropDownInline": 'Inline',
    "imageDisplayDropDownBreak": 'Break',
    "audioLayoutOptionDropDownInline": 'Inline',
    "audioLayoutOptionDropDownBreak": 'Break',
    "videoLayoutOptionDropDownInline": 'Inline',
    "videoLayoutOptionDropDownBreak": 'Break',
    "tableInsertRowDropDownBefore": 'Insert row before',
    "tableInsertRowDropDownAfter": 'Insert row after',
    "tableInsertRowDropDownDelete": 'Delete row',
    "tableInsertColumnDropDownLeft": 'Insert column left',
    "tableInsertColumnDropDownRight": 'Insert column right',
    "tableInsertColumnDropDownDelete": 'Delete column',
    "tableVerticalAlignDropDownTop": 'Align Top',
    "tableVerticalAlignDropDownMiddle": 'Align Middle',
    "tableVerticalAlignDropDownBottom": 'Align Bottom',
    "tableStylesDropDownDashedBorder": 'Dashed Borders',
    "tableStylesDropDownAlternateRows": 'Alternate Rows',
    'pasteFormat': 'Paste Format',
    'pasteFormatContent': 'Choose the formatting action',
    'plainText': 'Plain Text',
    'cleanFormat': 'Clean',
    'keepFormat': 'Keep',
    'pasteDialogOk': 'OK',
    'pasteDialogCancel': 'Cancel',
    'fileManager': 'File Manager',
    'fileDialogHeader': 'File Browser',
    "formatsDropDownParagraph": 'Paragraph',
    'formatsDropDownCode': 'Code',
    'formatsDropDownQuotation': 'Blockquote',
    'formatsDropDownHeading1': 'Heading 1',
    'formatsDropDownHeading2': 'Heading 2',
    'formatsDropDownHeading3': 'Heading 3',
    'formatsDropDownHeading4': 'Heading 4',
    'fontNameSegoeUI': 'Segoe UI',
    'fontNameArial': 'Arial',
    'fontNameGeorgia': 'Georgia',
    'fontNameImpact': 'Impact',
    'fontNameTahoma': 'Tahoma',
    'fontNameTimesNewRoman': 'Times New Roman',
    'fontNameVerdana': 'Verdana',
    'numberFormatListNumber': 'Number',
    'numberFormatListLowerAlpha': 'Lower Alpha',
    'numberFormatListUpperAlpha': 'Upper Alpha',
    'numberFormatListLowerRoman': 'Lower Roman',
    'numberFormatListUpperRoman': 'Upper Roman',
    'numberFormatListLowerGreek': 'Lower Greek',
    'bulletFormatListDisc': 'Disc',
    'bulletFormatListCircle': 'Circle',
    'bulletFormatListSquare': 'Square',
    'numberFormatListNone': 'None',
    'bulletFormatListNone': 'None',
    'formatPainter': 'Format Painter',
    'emojiPicker': 'Emoji Picker',
    'embeddedCode': 'Embedded code',
    'pasteEmbeddedCodeHere': 'Paste embedded code here',
    'emojiPickerTypeToFind': 'Type to find',
    'emojiPickerNoResultFound': 'No results found',
    'emojiPickerTrySomethingElse': 'Try something else',
    'linkAriaLabel': 'Open in new window',
    'unsupportedImage': 'Unsupported file format',
    'mergecells': 'Merge cells',
    'verticalsplit': 'Vertical split',
    'horizontalsplit': 'Horizontal split'
};
export var toolsLocale = {
    'alignments': 'alignments',
    'justifyleft': 'justifyLeft',
    'justifycenter': 'justifyCenter',
    'justifyright': 'justifyRight',
    'justifyfull': 'justifyFull',
    'fontname': 'fontName',
    'fontsize': 'fontSize',
    'fontcolor': 'fontColor',
    'backgroundcolor': 'backgroundColor',
    'bold': 'bold',
    'italic': 'italic',
    'underline': 'underline',
    'strikethrough': 'strikethrough',
    'clearformat': 'clearFormat',
    'clearall': 'clearAll',
    'cut': 'cut',
    'copy': 'copy',
    'paste': 'paste',
    'unorderedlist': 'unorderedList',
    'orderedlist': 'orderedList',
    'indent': 'indent',
    'outdent': 'outdent',
    'numberformatlist': 'numberFormatList',
    'bulletformatlist': 'bulletFormatList',
    'undo': 'undo',
    'redo': 'redo',
    'filemanager': 'fileManager',
    'superscript': 'superscript',
    'subscript': 'subscript',
    'createlink': 'createLink',
    'openlink': 'openLink',
    'editlink': 'editLink',
    'removelink': 'removeLink',
    'openimagelink': 'openLink',
    'editimagelink': 'editLink',
    'removeimagelink': 'removeLink',
    'image': 'image',
    'audio': 'audio',
    'video': 'video',
    'replace': 'replace',
    'audioreplace': 'audioReplace',
    'videoreplace': 'videoReplace',
    'videoalign': 'videoAlign',
    'videodimension': 'videoDimension',
    'audioremove': 'audioRemove',
    'videoremove': 'videoRemove',
    'audiolayoutoption': 'audioLayoutOption',
    'videolayoutoption': 'videoLayoutOption',
    'align': 'align',
    'caption': 'caption',
    'remove': 'remove',
    'insertlink': 'insertLink',
    'display': 'display',
    'alttext': 'alternateHeader',
    'dimension': 'dimension',
    'fullscreen': 'fullscreen',
    'maximize': 'maximize',
    'minimize': 'minimize',
    'lowercase': 'lowerCase',
    'uppercase': 'upperCase',
    'print': 'print',
    'formats': 'formats',
    'sourcecode': 'sourcecode',
    'preview': 'preview',
    'viewside': 'viewside',
    'insertcode': 'insertCode',
    'blockquote': 'blockquote',
    'tablerows': 'tableRows',
    'tablecolumns': 'tableColumns',
    'tablecellhorizontalalign': 'tableCellHorizontalAlign',
    'tablecellverticalalign': 'tableCellVerticalAlign',
    'createtable': 'createTable',
    'removetable': 'removeTable',
    'tableheader': 'tableHeader',
    'tableremove': 'tableRemove',
    'tablecellbackground': 'tableCellBackground',
    'tableeditproperties': 'tableEditProperties',
    'styles': 'styles',
    'insertcolumnleft': 'insertColumnLeft',
    'insertcolumnright': 'insertColumnRight',
    'deletecolumn': 'deleteColumn',
    'aligntop': 'AlignTop',
    'alignmiddle': 'AlignMiddle',
    'alignbottom': 'AlignBottom',
    'insertrowbefore': 'insertRowBefore',
    'insertrowafter': 'insertRowAfter',
    'deleterow': 'deleteRow',
    'formatpainter': 'formatPainter',
    'emojipicker': 'emojiPicker',
    'embeddedCode': 'Embedded code',
    'pasteEmbeddedCodeHere': 'Paste embedded code here',
    'emojiPickerTypeToFind': 'Type to find',
    'emojiPickerNoResultFound': 'No results found',
    'emojiPickerTrySomethingElse': 'Try something else',
    'imageLinkAriaLabel': 'Open in new window',
};
export var fontNameLocale = [
    { locale: 'fontNameSegoeUI', value: 'Segoe UI' },
    { locale: 'fontNameArial', value: 'Arial,Helvetica,sans-serif' },
    { locale: 'fontNameGeorgia', value: 'Georgia,serif' },
    { locale: 'fontNameImpact', value: 'Impact,Charcoal,sans-serif' },
    { locale: 'fontNameTahoma', value: 'Tahoma,Geneva,sans-serif' },
    { locale: 'fontNameTimesNewRoman', value: 'Times New Roman,Times,serif' },
    { locale: 'fontNameVerdana', value: 'Verdana,Geneva,sans-serif' }
];
export var formatsLocale = [
    { locale: 'formatsDropDownParagraph', value: 'P' },
    { locale: 'formatsDropDownCode', value: 'Pre' },
    { locale: 'formatsDropDownHeading1', value: 'H1' },
    { locale: 'formatsDropDownHeading2', value: 'H2' },
    { locale: 'formatsDropDownHeading3', value: 'H3' },
    { locale: 'formatsDropDownHeading4', value: 'H4' }
];
export var numberFormatListLocale = [
    { locale: 'numberFormatListNone', value: 'none' },
    { locale: 'numberFormatListNumber', value: 'decimal' },
    { locale: 'numberFormatListLowerAlpha', value: 'lower-alpha' },
    { locale: 'numberFormatListUpperAlpha', value: 'upper-alpha' },
    { locale: 'numberFormatListLowerRoman', value: 'lower-roman' },
    { locale: 'numberFormatListUpperRoman', value: 'upper-roman' },
    { locale: 'numberFormatListLowerGreek', value: 'lower-greek' }
];
export var bulletFormatListLocale = [
    { locale: 'bulletFormatListNone', value: 'none' },
    { locale: 'bulletFormatListDisc', value: 'disc' },
    { locale: 'bulletFormatListCircle', value: 'circle' },
    { locale: 'bulletFormatListSquare', value: 'square' },
];
